'use client';

import { useEffect, useRef, useState } from 'react';

export default function ViewportVideo() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.25 },
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="iframeop">
      {inView && (
        <iframe
          title="dyste. music video"
          className="responsive-iframe"
          src="https://www.youtube-nocookie.com/embed/hFYchi6k0So?autoplay=1&mute=1"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
        />
      )}
    </div>
  );
}